module.exports = __webpack_public_path__ + "static/sustainability-impact-landing-hero-desktop.1e7e6645.webp";